import { R } from '@core/utils/r';
import { SubscriptionBoardResponse, SubscriptionBoardId } from '@business/entities/marketing';
import { Endpoint } from '@business/api/endpoint';

/** Subscription Boards */
export function fetchSubscriptionBoards(options: { search?: string } = {}) {
  const params = R.objectCompact({ search: options.search });
  return Endpoint.get<SubscriptionBoardResponse[]>(`@gc/subscription-board`, { params });
}

export function createSubscriptionBoard(data: Partial<SubscriptionBoardResponse>) {
  return Endpoint.post<SubscriptionBoardResponse>(`@gc/subscription-board`, { data });
}

export function updateSubscriptionBoard(subBoardId: SubscriptionBoardId, data: Partial<SubscriptionBoardResponse>) {
  return Endpoint.patch<SubscriptionBoardResponse>(`@gc/subscription-board/${subBoardId}`, { data });
}

export function deleteSubscriptionBoard(subBoardId: SubscriptionBoardId) {
  return Endpoint.delete<void>(`@gc/subscription-board/${subBoardId}`);
}

export function fetchSubscriptionBoard(subBoardId: SubscriptionBoardId) {
  return Endpoint.get<SubscriptionBoardResponse>(`@gc/subscription-board/${subBoardId}`);
}
